<app-page-shell variant="default" [embedded]="isModal()">
  <app-sb-input-form [mode]="projectId() ? 'edit' : 'add'"
                     [title]="(projectId() ? 'Edit' : 'Add') + ' Project'"
                     [stickyFooter]="!isModal()"
                     [embedded]="isModal()"
                     (submitted)="addProject()"
                     (cancelled)="onCancel()">
    <div [formGroup]="addProjectForm">

      <app-sb-input-form-section title="Project details">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-12 mb-3 project-add-image-container">
            <app-sb-input-image
              formControlName="image"
              label="Project Logo"
              [autoUpload]="true"
              [projectId]="projectId()"
              [clientId]="clientId"
              [showFileBrowser]="false"
              accept="jpg,jpeg,png,webp"
              [minWidth]="150"
              [minHeight]="150"
              [maxWidth]="2048"
              [maxHeight]="2048"
              [maxFileSize]="5242880">
            </app-sb-input-image>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            <div class="row">
              <div class="col-md-6 mb-3">
                <app-sb-input-text
                  label="Project's Name"
                  [required]="true"
                  formControlName="title"
                  [error]="fieldError('title', 'Name is required')"
                  (focusout)="generateSlug(); validateSlug()">
                </app-sb-input-text>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-text
                  label="Project's Slug"
                  [required]="true"
                  help="This is a unique key for this project."
                  formControlName="slug"
                  [error]="fieldError('slug', 'Project\'s Slug is required')"
                  (focusout)="validateSlug()">
                </app-sb-input-text>
              </div>
              @if (currentUser()?.can('change-client', 'project')) {
              <div class="col-md-6 mb-3">
                <app-sb-input-select
                  label="Client Name"
                  [items]="planners()"
                  labelKey="name"
                  valueKey="id"
                  [required]="!!f.client_id.validator"
                  formControlName="client_id"
                  [error]="fieldError('client_id', 'Client Name is required')"
                  (selectionChange)="onClientChange($event)">
                </app-sb-input-select>
              </div>
              }
              <div class="col-md-6 mb-3">
                <app-sb-input-text label="Project's Location" formControlName="venue"></app-sb-input-text>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-select
                  label="Industry"
                  [items]="industryList()"
                  formControlName="industry">
                </app-sb-input-select>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-select
                  label="Event Type"
                  [items]="eventList"
                  [required]="true"
                  [clearable]="false"
                  formControlName="event_type"
                  [error]="fieldError('event_type', 'Event Type is required')">
                </app-sb-input-select>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-select
                  label="Registration Type"
                  [items]="isPaidList"
                  [required]="true"
                  [clearable]="false"
                  formControlName="is_paid"
                  [error]="fieldError('is_paid', 'Registration Type is required')">
                </app-sb-input-select>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-number
                  label="Average Ticket Price"
                  [min]="0"
                  step="any"
                  formControlName="register_average_price">
                </app-sb-input-number>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-select
                  label="Currency"
                  [items]="currencyList()"
                  labelKey="name"
                  valueKey="code"
                  [clearable]="false"
                  formControlName="currency">
                </app-sb-input-select>
              </div>
              <div class="col-md-6 mb-3">
                <app-sb-input-timezone label="Time Zone" formControlName="timezone"></app-sb-input-timezone>
              </div>
            </div>
          </div>
        </div>
      </app-sb-input-form-section>

      <app-sb-input-form-section title="Dates">
        <div class="row">
          <div class="col-lg-3 col-md-6 mb-3">
            <app-sb-input-time
              type="date"
              label="Event Start Date"
              [required]="true"
              [timeZone]="f.timezone.value || null"
              formControlName="start_date"
              (entryDone)="clearEndBefore($event, 'end_date', 'end_time')"
              [error]="fieldError('start_date', 'Start Date is required')">
            </app-sb-input-time>
          </div>
          <div class="col-lg-3 col-md-6 mb-3">
            <app-sb-input-time type="time" label="Event Start Time" quickPicks="none" [timeZone]="f.timezone.value || null" formControlName="start_time"></app-sb-input-time>
          </div>
          <div class="col-lg-3 col-md-6 mb-3">
            <app-sb-input-time
              type="date"
              label="Event End Date"
              [required]="true"
              [timeZone]="f.timezone.value || null"
              [min]="f.start_date.value || null"
              formControlName="end_date"
              [error]="fieldError('end_date', 'End Date is required')">
            </app-sb-input-time>
          </div>
          <div class="col-lg-3 col-md-6 mb-3">
            <app-sb-input-time type="time" label="Event End Time" quickPicks="none" [timeZone]="f.timezone.value || null" formControlName="end_time"></app-sb-input-time>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-time
              type="date"
              label="Activation Start Date"
              [required]="true"
              [timeZone]="f.timezone.value || null"
              formControlName="activation_starts_at"
              (entryDone)="clearEndBefore($event, 'activation_ends_at')"
              [error]="fieldError('activation_starts_at', 'Activation Start Date is required')">
            </app-sb-input-time>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-time
              type="date"
              label="Activation End Date"
              [required]="true"
              [timeZone]="f.timezone.value || null"
              help="The project counts as finished from the day after this date."
              [min]="f.activation_starts_at.value || null"
              formControlName="activation_ends_at"
              [error]="fieldError('activation_ends_at', 'Activation End Date is required')">
            </app-sb-input-time>
          </div>
        </div>

        <app-sb-input-complex-multiple
          label="Project's Important Dates"
          [emptyItem]="importantDateEmptyItem"
          [trailingEmptyRow]="true"
          formControlName="dates">
          <ng-template sbInputComplexRow let-row let-update="update">
            <div class="col-lg-6 col-md-6 mb-3">
              <app-sb-input-text
                label="Name"
                [ngModel]="row['important_text']"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="update('important_text', $event)">
              </app-sb-input-text>
            </div>
            <div class="col-10 col-lg-4 col-md-4 mb-3">
              <app-sb-input-time
                type="date"
                label="Date"
                [timeZone]="f.timezone.value || null"
                [ngModel]="row['important_date']"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="update('important_date', $event)">
              </app-sb-input-time>
            </div>
          </ng-template>
        </app-sb-input-complex-multiple>
      </app-sb-input-form-section>

      <app-sb-input-form-section title="Links and messages">
        <div class="row">
          <div class="col-md-6 mb-3">
            <app-sb-cta-url-input
              label="Call To Action Url"
              [required]="true"
              help="This could be your registration link or downloadable form link"
              formControlName="registration_url"
              [projectId]="project?.id || null"
              [clientId]="clientId"
              [utmParams]="callToActionUtmParams()"
              [error]="fieldError('registration_url', 'Please enter Registration Link.')">
            </app-sb-cta-url-input>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-url-input
              label="Project's Website"
              [required]="true"
              formControlName="website_url"
              [error]="fieldError('website_url', 'Please enter Project\'s Website.')">
            </app-sb-url-input>
          </div>
          <div class="col-md-6 mb-3 d-none">
            <app-sb-input-text label="Google UTM Params" formControlName="google_utm_params"
              [error]="fieldError('google_utm_params')"></app-sb-input-text>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-text
              label="Emails Source Message"
              help="This will be displayed to your audience in the emails they receive. Example: You signed up to our newsletter in our previous event"
              formControlName="emails_source_message">
            </app-sb-input-text>
          </div>
          <div class="col-12 mb-3">
            <app-sb-input-text
              label="Third-party Event/Project ID"
              help="This will be used to find the related project on Snöball"
              formControlName="third_party_project_id">
            </app-sb-input-text>
          </div>
        </div>
      </app-sb-input-form-section>

      <app-sb-input-form-section title="Social Media Information">
        <div class="row">
          <div class="col-12 mb-3">
            <app-sb-input-text label="Project's Official Hashtag" formControlName="hashtag"></app-sb-input-text>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-url
              label="Facebook"
              placeholder="https://www.facebook.com/snoball/"
              formControlName="facebook"
              [error]="fieldError('facebook')">
            </app-sb-input-url>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-url
              label="Twitter"
              placeholder="https://www.twitter.com/snoball/"
              formControlName="twitter"
              [error]="fieldError('twitter')">
            </app-sb-input-url>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-url
              label="LinkedIn"
              placeholder="https://www.linkedin.com/in/username/"
              formControlName="linkedin"
              [error]="fieldError('linkedin')">
            </app-sb-input-url>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-url
              label="Instagram"
              placeholder="https://www.instagram.com/snoball/"
              formControlName="instagram"
              [error]="fieldError('instagram')">
            </app-sb-input-url>
          </div>
        </div>

        <app-sb-input-complex-multiple
          label="Other social networks"
          [emptyItem]="socialEmptyItem"
          [trailingEmptyRow]="true"
          formControlName="socials">
          <ng-template sbInputComplexRow let-row let-update="update">
            <div class="col-lg-6 col-md-6 mb-3">
              <app-sb-input-text
                label="Name"
                [ngModel]="row['social_label']"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="update('social_label', $event)">
              </app-sb-input-text>
            </div>
            <div class="col-10 col-lg-4 col-md-4 mb-3">
              <app-sb-input-text
                label="URL"
                [ngModel]="row['social_value']"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="update('social_value', $event)">
              </app-sb-input-text>
            </div>
          </ng-template>
        </app-sb-input-complex-multiple>
      </app-sb-input-form-section>

      <app-sb-input-form-section title="Settings">
        <div class="row">
          <div class="col-12 mb-2">
            <app-sb-input-checkbox
              label="Can Speakers update their session"
              formControlName="sessions_can_be_updated_influencer">
            </app-sb-input-checkbox>
          </div>
          <div class="col-12 mb-3">
            <app-sb-input-checkbox
              label="Can Exhibitors update their booth number"
              formControlName="booth_can_be_updated_influencer">
            </app-sb-input-checkbox>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-text
              label="Display DateTime Format"
              placeholder="MMMM D, YYYY [at] h:mm A"
              [help]="displayDatetimeFormatHelp"
              formControlName="display_datetime_format">
            </app-sb-input-text>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-select
              label="Widget Version"
              [items]="widgetVersionList"
              [clearable]="false"
              formControlName="widget_version">
            </app-sb-input-select>
          </div>
          <div class="col-md-6 mb-3">
            <app-sb-input-select
              label="Activate CDN for Widget"
              [items]="inheritedSwitchList"
              [clearable]="false"
              formControlName="widget_cdn_enabled">
            </app-sb-input-select>
          </div>
          @if (isSuperAdmin) {
          <div class="col-md-6 mb-3">
            <app-sb-input-select
              label="Visual Rendering System"
              [items]="renderingSystemList"
              [clearable]="false"
              formControlName="rendering_system">
            </app-sb-input-select>
          </div>
          }
        </div>
      </app-sb-input-form-section>

      <app-sb-input-form-section
        title="Exclude Emails / IPs"
        description="Activity from these emails and IP addresses is left out of the project's statistics.">
        <div class="row">
          <div class="col-12 mb-3">
            <app-sb-input-email
              label="Exclude Emails"
              description="Press Enter or comma after each email"
              placeholder="demo@snoball.it"
              [multiple]="true"
              delimiter=","
              formControlName="exclude_emails">
            </app-sb-input-email>
          </div>
          <div class="col-12 mb-3">
            <app-sb-input-ip
              label="Exclude IPs"
              description="Press Enter or comma after each IP address"
              placeholder="127.0.0.1"
              [multiple]="true"
              delimiter=","
              formControlName="exclude_ips">
            </app-sb-input-ip>
          </div>
        </div>
      </app-sb-input-form-section>

      <app-sb-input-form-section
        title="Custom Variables"
        description="Custom variables can be used to easily customize certain aspects of the campaign pages, campaign emails, etc">
        <div class="row">
          @for (field of customFields; track field; let i = $index) {
          <div class="col-md-6 mb-3">
            <app-sb-input-text
              [label]="'Custom ' + (i + 1)"
              [formControlName]="field"
              [showVariableBrowser]="true"
              [variableClickFor]="field"
              [showFileBrowser]="!!clientId"
              [clientId]="clientId"
              [projectId]="projectId()">
            </app-sb-input-text>
          </div>
          }
        </div>
      </app-sb-input-form-section>

      @if (currentUser()?.can('index.all', 'project')) {
      <app-sb-input-form-section title="Notes">
        <app-sb-input-textarea
          label="Notes"
          placeholder="Add notes"
          [rows]="4"
          formControlName="notes">
        </app-sb-input-textarea>
      </app-sb-input-form-section>
      }

      @if (currentUser()?.can('index.all', 'project')) {
      <app-sb-input-form-section title="Report Analysis">
        <app-sb-input-textarea
          label="Report Analysis"
          [wysiwyg]="true"
          [rows]="12"
          [showFileBrowser]="true"
          [clientId]="clientId"
          [projectId]="projectId()"
          formControlName="report_analysis">
        </app-sb-input-textarea>
      </app-sb-input-form-section>
      }

    </div>
    <ng-template sbInputFormActions>
      <div class="sb-form__footer-actions">
        <app-sb-button
          variant="primary"
          [label]="projectId() ? 'Update' : 'Next'"
          [icon]="projectId() ? 'fa fa-check' : 'fa fa-arrow-right'"
          [iconPosition]="projectId() ? 'start' : 'end'"
          type="submit"></app-sb-button>
      </div>
    </ng-template>
  </app-sb-input-form>
</app-page-shell>
